module.exports = __webpack_public_path__ + "static/media/calendar-icon.9a772a07.svg";